module.exports = __webpack_public_path__ + "img/REFRESH_STATUS.ddbdfebc.svg";